import QuadraticEquationSolver from "./QuadraticEquationSolver";
export default QuadraticEquationSolver